<template>
  <div class="c-sidebar-options">
    <div v-if="groupCustomizationsLength > 1" class="c-sidebar-options__header">
      <strong v-if="customization.name" class="is-size-6">
        {{ customization.name }}
      </strong>
    </div>
    <div
      class="c-sidebar-options__content"
      v-for="(option, index) in customization.group_customizations"
      :key="index"
    >
      <div
        v-if="groupCustomizationsLength >= 1"
        class="c-sidebar-options__header"
      >
        <strong class="is-size-6">
          {{ option.admin_options.name }}
        </strong>
        <p v-if="option.admin_options.description">
          {{ option.admin_options.description }}
        </p>
      </div>
      <component
        v-bind:is="getComponentName(option.admin_options.type)"
        :customization="option"
        @newChange="setNewChange"
      >
      </component>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const PATH = './CustomizationsOptions/'

export default {
  props: {
    customization: {
      type: Object,
      required: true,
    },
  },

  components: {
    OptionImagesColors: () => import(PATH + 'OptionImagesColors.vue'),
    OptionGradients: () => import(PATH + 'OptionGradients.vue'),
    OptionGraphics: () => import(PATH + 'OptionGraphics.vue'),
    OptionColors: () => import(PATH + 'OptionColors.vue'),
    OptionInputs: () => import(PATH + 'OptionInputs.vue'),
    OptionFonts: () => import(PATH + 'OptionFonts.vue'),
    OptionBoolean: () => import(PATH + 'OptionBoolean.vue'),
  },

  computed: {
    groupCustomizationsLength() {
      return this.customization?.group_customizations.length
    },
  },

  methods: {
    ...mapActions({
      setNewChange: 'theme/setNewCustomizationOption',
    }),

    getComponentName(name) {
      if (name === 'image_color') return 'OptionImagesColors'
      if (name === 'image') return 'OptionImagesColors'
      if (name === 'gradient') return 'OptionGradients'
      if (name === 'graphic') return 'OptionGraphics'
      if (name === 'color') return 'OptionColors'
      if (name === 'input') return 'OptionInputs'
      if (name === 'font') return 'OptionFonts'
      if (name === 'boolean') return 'OptionBoolean'
    },
  },
}
</script>

<style lang="scss">
.c-sidebar-options {
  padding: 16px 12px;

  &__header {
    margin-bottom: 16px;
    color: $gray-6;
    > strong {
      color: $gray-7;
    }
  }

  &__content {
    margin-bottom: 48px;
    &:last-child {
      margin-bottom: 16px;
    }
  }
}
</style>
